import { styled } from '@mui/material/styles'
import { ReactElement } from 'react'
import dynamic from 'next/dynamic'
import Box from '@mui/material/Box'
import Image from '@/components/Image'
import { SPACING_VARIABLES } from '@/theme/themeOptions/vars'
import { ZINDEXES } from '@/constants/zindexes'
import { BASE_URL } from '@/config'
import { getLogoPath } from '@/helpers/api'

const NavigationMenu = dynamic(() => import('@/components/header/NavigationMenu'), { ssr: false })

const HeaderStyled = styled(Box)(({ theme }) => ({
  left: 0,
  position: 'fixed',
  top: 0,
  width: '100%',

  borderBottom: `1px solid ${theme.palette.divider}`,
  boxSizing: 'border-box',

  height: SPACING_VARIABLES.APP_HEADER_HEIGHT,
  [theme.breakpoints.down('sm')]: {
    height: SPACING_VARIABLES.MOBILE_APP_HEADER_HEIGHT,
    img: {
      maxWidth: '159px',
      height: 'auto'
    }
  },
  background: theme.palette.common.white,

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 10px',
  zIndex: ZINDEXES.HEADER_LAYER
}))

export const Header = (): ReactElement => {
  return (
    <HeaderStyled component="div" qa-attribute="header">
      <Image
        src={getLogoPath('/?logo_manager_logo')}
        width={180}
        height={32}
        href={BASE_URL}
        alt="SimScale logo"
        priority
      />
      <NavigationMenu />
    </HeaderStyled>
  )
}
